import React, { Fragment, useEffect, useState } from "react";
/** @jsxImportSource @emotion/react */
import tw, { css } from "twin.macro";
import MainLayout from "../../components/MainLayout/MainLayout";
import tlBG from "../../assets/images/gradientBg.png";
import fbBG from "../../assets/images/fallback.jpeg";
import {
	CreateTimelinePost,
	EmptyData,
	PageTitleNavigation,
	SplitPane,
	TimelineComp,
} from "../../components";
import { useFetchWeddingPost, useTimeline } from "../../redux/api/Timeline";
import {
	AvatarContainer,
	StoryAvatar,
	StoryMode,
	TimelineContainer,
	Wrapper,
} from "./component";
import { isEmpty } from "../../lib/helpers/helpers";
import TimelineSkeleton from "../../components/TimelineSharedComponents/TimelineSkeleton";
import { Avatar, Modal, Skeleton, Typography } from "antd";
import { v4 } from "uuid";
import dayjs from "dayjs";
import { useFetchUpcomingWeddings } from "../../redux/api/WeddingAPI";
import { FloatBtn } from "../../lib/styles/styleLibrary";

export const active = (props) => css`
	${tw`font-bold uppercase shadow rounded-2xl min-w-min text-appTextDark inline-flex gap-2 items-center justify-center py-4 hover:(text-appTextDark bg-gray-100 border-none) active:(text-appTextDark  bg-gray-100 border-none) focus:(text-appTextDark  bg-gray-200 border-none)`}
	font-family: Poppins;
	background-color: rgba(151, 151, 189, 0.2);
	line-height: 12px;
	letter-spacing: 0.5px;
	font-size: 0.875rem;
	@media (max-width: 1217px) {
		font-size: 0.65rem;
	}
`;
export const inactive = (props) => css`
	${tw`font-medium uppercase shadow-sm rounded-2xl min-w-min text-appTextFaded inline-flex gap-2 items-center justify-center py-4 hover:(text-appTextDark bg-gray-100 border-none) active:(text-appTextDark  bg-gray-100 border-none) focus:(border-none  bg-gray-200)`}
	font-family: Poppins;
	background-color: rgba(166, 166, 175, 0.082);
	line-height: 12px;
	letter-spacing: 0.5px;
	font-size: 0.875rem;
	@media (max-width: 1217px) {
		font-size: 0.65rem;
	}
`;

const Timeline = (props) => {
	const [weddingId, setWeddingId] = useState(null);
	const [visible, setVisible] = useState(false);
	const [all, setAll] = useState(true);
	const { data: upcomingWeddings, isLoading: upcomingLoading } =
		useFetchUpcomingWeddings();
	const [timelineData, setTimelineData] = useState([]);
	const [tldata, setTlData] = useState({
		date: "",
		name: "",
	});
	const {
		data: timeline,
		isLoading: tlLoading,
		refetch,
	} = useTimeline({ page: 20 });
	const { data: weddingTimelinePost, isLoading: wtlLoading } =
		useFetchWeddingPost({
			weddingId,
			all,
		});

	useEffect(() => {
		if (isEmpty(timeline)) {
			return;
		}
		all
			? setTimelineData(timeline?.timeline)
			: setTimelineData(weddingTimelinePost?.wedding_posts);
	}, [timeline, all, weddingTimelinePost]);

	let result = timeline?.timeline.reduce((unique, o) => {
		if (!unique.some((wed) => wed.weddingId === o.weddingId)) {
			unique.push(o);
		}
		return unique;
	}, []);

	return (
		<MainLayout tw="relative">
			<Wrapper>
				<PageTitleNavigation title={"My Timeline"} showBack />

				<SplitPane
					wrapDirection={"column"}
					mainHeightAdjust={"10rem"}
					leftHeightAdjust={"10rem"}
					rightHeightAdjust={"10rem"}
					left={
						<div tw=" w-full h-auto flex flex-col justify-center ">
							<StoryMode>
								<AvatarContainer onClick={() => setAll(true)}>
									<StoryAvatar>
										<Avatar
											size={"large"}
											shape={"circle"}
											tw="h-12 w-12"
											src={fbBG}
										/>
									</StoryAvatar>
									<h4>All</h4>
								</AvatarContainer>

								{tlLoading
									? Array.apply(null, Array(3)).map((i) => {
											return (
												<Skeleton.Avatar
													active
													size="large"
													shape="circle"
													key={v4()}
												/>
											);
									  })
									: result?.map((tl, i) => {
											return (
												<AvatarContainer
													key={v4()}
													onClick={() => {
														setAll(false);
														setWeddingId(
															tl.weddingId
														);
														setTlData({
															date: tl.wedding
																.date,
															name: `${tl.wedding.bride_firstname} & ${tl.wedding.groom_firstname}`,
														});
													}}>
													<StoryAvatar>
														<Avatar
															size={"large"}
															shape={"circle"}
															tw="h-12 w-12"
															src={
																tl.wedding
																	.story_cover_image_url ||
																tlBG
															}
														/>
													</StoryAvatar>
													<h4>
														{
															tl.wedding
																.bride_firstname[0]
														}
														{" & "}
														{
															tl.wedding
																.groom_firstname[0]
														}
													</h4>
												</AvatarContainer>
											);
									  })}
							</StoryMode>
							{!all && (
								<>
									<Typography.Title
										level={4}
										tw="m-0! mt-4! opacity-80">
										{tldata?.name}
									</Typography.Title>
									<Typography.Title
										level={4}
										tw="text-appGray-50! m-0! text-sm! mb-8!">
										{dayjs(tldata?.date).format(
											"dddd, D MMMM YYYY"
										)}
									</Typography.Title>
								</>
							)}
							<TimelineContainer tw="overflow-x-hidden overflow-y-auto gap-8">
								{tlLoading || wtlLoading ? (
									Array.apply(null, Array(3)).map(() => {
										return (
											<TimelineSkeleton
												large
												key={v4()}
											/>
										);
									})
								) : isEmpty(timelineData) ? (
									<EmptyData />
								) : (
									timelineData?.map((tl, i) => {
										return (
											<Fragment key={i}>
												<TimelineComp
													likes={tl.likes_count}
													comments={tl.comments_count}
													imageBg={
														tl.wedding
															.story_cover_image_url
													}
													timelineData={tl}
													loading={tlLoading}
													large
													handleComment={() => {}}
												/>
											</Fragment>
										);
									})
								)}
							</TimelineContainer>
						</div>
					}
					right={
						<CreateTimelinePost
							refetch={refetch}
							upcomingLoading={upcomingLoading}
							upcomingWeddings={upcomingWeddings?.weddings}
							hideOnMobile={true}
						/>
					}
				/>
				<Modal
					footer=""
					visible={visible}
					centered
					onCancel={() => setVisible(false)}
					maskClosable={false}>
					<CreateTimelinePost
						hideOnMobile={false}
						refetch={refetch}
						upcomingLoading={upcomingLoading}
						upcomingWeddings={upcomingWeddings?.weddings}
						setVisible={setVisible}
					/>
				</Modal>
			</Wrapper>
			<FloatBtn onClick={() => setVisible(true)}>+</FloatBtn>
		</MainLayout>
	);
};

export default Timeline;
